import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

export const hintStyle = css`
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;
